import React from 'react'
import AboutBanner from '../../components/AboutJ10Components/AboutBanner'
import AboutUsCount from '../../components/AboutJ10Components/AboutUsCount'

const AboutJ10 = () => {
    return (
        <div>
            <AboutBanner />
            <AboutUsCount />
        </div>
    )
}

export default AboutJ10
